var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRemoveFromCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 50.969,
    "data-name": "Remove from Basket",
    viewBox: "0 0 60 50.969",
    id: "remove-from-basket",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757d8f",
    fillRule: "evenodd",
    d: "M631.74 181.817a3.665 3.665 0 0 1-3.58-2.864l-2.78-19.1H644a12.722 12.722 0 0 0-.34 2.924 13.284 13.284 0 0 0 11.12 13.129l-.42 2.944a3.69 3.69 0 0 1-3.6 2.965h-19.02z",
    opacity: 0.1,
    transform: "translate(-610 -145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#757d8f",
    fillRule: "evenodd",
    d: "M658.82 175.908a13.283 13.283 0 0 0-1.98-26.4 13.081 13.081 0 0 0-11.2 6.312H624.6l-1.3-4.961a7.821 7.821 0 0 0-7.54-5.869H612a2.017 2.017 0 0 0 0 4.033h3.76a3.812 3.812 0 0 1 3.68 2.864l1.68 6.393.02.061 3.08 21.3a7.659 7.659 0 0 0 1.44 3.146 7.032 7.032 0 1 0 9.88 3.066h11.44a6.74 6.74 0 0 0-.7 3.045 7.03 7.03 0 1 0 10.58-6.111 8.383 8.383 0 0 0 1.44-3.247zm-29.62 16.033a3.045 3.045 0 1 1 3.02-3.045 3.047 3.047 0 0 1-3.02 3.045zm2.54-10.124a3.665 3.665 0 0 1-3.58-2.864l-2.78-19.1H644a12.722 12.722 0 0 0-.34 2.924 13.284 13.284 0 0 0 11.12 13.129l-.42 2.944a3.69 3.69 0 0 1-3.6 2.965h-19.02zm21.56 10.124a3.045 3.045 0 1 1 3.04-3.045 3.043 3.043 0 0 1-3.04 3.045zm3.54-19.9a8.939 8.939 0 0 1-1.48-.121 9.256 9.256 0 0 1-7.7-9.136 8.877 8.877 0 0 1 .48-2.924 9.277 9.277 0 0 1 8.7-6.312 9.247 9.247 0 0 1 0 18.488z",
    transform: "translate(-610 -145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f27373",
    fillRule: "evenodd",
    d: "M660.853 164.8h-8.045a2.017 2.017 0 0 1 0-4.034h8.045a2.017 2.017 0 0 1 0 4.034z",
    transform: "translate(-610 -145)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveFromCart);
export default __webpack_public_path__ + "static/media/Icon - remove_from_cart.2c71e4f6f6d9817e7cdfa408d11b7d4c.svg";
export { ForwardRef as ReactComponent };